<template>
  <a
    class="button-service flex-vcenter"
    :href="service.url"
    :class="color"
  >
    <img
      :src="service.image || require('../../assets/media/logos/logo_lde.svg')"
      :alt="`Logo du service ${service.nom}`"
      @error="service.image = null"
    />
    <div>
      <p>
        <span
          class="name s5 bold"
          v-html="service.nom"
        />
        <span
          v-if="service.short_description"
          class="info s6 light"
          v-html="` &mdash; ${service.short_description}`"
        />
      </p>
      <p
        v-if="service.description"
        class="description text-regular"
        v-html="service.description"
      />
    </div>
  </a>
</template>

<script>
import { defineComponent } from "vue";
/**
 * Bouton permettant d'ouvrir le service LDE associé.
 */
export default defineComponent({
  name: "ButtonService",
  props: {
    /**
     * Informations du service (icône, lien, nom, description…).
     */
    service: {
      type: Object,
      required: true,
    },
    /**
     * Change la couleur du bouton.
     */
    color: {
      type: String,
      validator: (value) => ["white", "blue", "yellow"].includes(value),
      default: "white",
    },
  },
  data() {
    return {
      imgName: this.service.groupe,
    };
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/components/buttons/button_service.scss";
</style>
